import type { MPLOffer, MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import type { TOffer } from 'shared/types/TRankingService';

export const isMplOffer = (offer: TOffer | MPLPreApprovalOffer | MPLOffer): offer is MPLOffer => {
  return offer.type === 'mplOffer';
};
